import { binarySelectOptions, useRouter } from '@application/utils';
import type { PromoNewsletterFormValues, PromoNewsletterProps } from '@presentation/components';
import {
  Button,
  Container,
  InputCheckboxField,
  InputField,
  InputLabel,
  InputRadioField,
  InputWrapper,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { Formik } from 'formik';
import type { FC } from 'react';
import * as Styled from './styled';

export const LeadForm: FC<PromoNewsletterProps> = (props) => {
  const { form, hideHasADogField = false, ...rest } = props;
  const { translate } = useTranslation();
  const { routeLocationDescriptor } = useRouter();

  const yesNoOptions = binarySelectOptions(translate);

  return (
    <Container>
      <Styled.Card {...rest}>
        <Styled.Title>{translate('quiz.noUser.title')}</Styled.Title>
        <Formik<PromoNewsletterFormValues> {...form}>
          {({ submitForm, errors, isSubmitting }) => (
            <>
              <InputWrapper>
                <InputField
                  placeholder={translate('common.inputs.email.placeholder')}
                  name="email"
                  type="email"
                />
              </InputWrapper>
              {hideHasADogField ? null : (
                <InputWrapper>
                  <InputLabel required>{translate('common.inputs.hasADog')}</InputLabel>
                  <InputRadioField<boolean>
                    name="hasADog"
                    variant="blue"
                    grow
                    options={yesNoOptions}
                    hasError={!!errors.hasADog}
                  />
                </InputWrapper>
              )}
              <InputWrapper>
                <InputCheckboxField name="marketingEmailConsent">
                  <Styled.TermsContainer
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: translate('common.inputs.termsPolicyEmailMarketing.label').replace(
                        '$link',
                        routeLocationDescriptor('privacy').pathname ?? '',
                      ),
                    }}
                  />
                </InputCheckboxField>
              </InputWrapper>
              <InputWrapper>
                <Button
                  color="blue"
                  onClick={submitForm}
                  disabled={isSubmitting}
                  loading={isSubmitting}
                >
                  {translate('common.buttons.showResults')}
                </Button>
              </InputWrapper>
            </>
          )}
        </Formik>
      </Styled.Card>
    </Container>
  );
};
